<template>
  <v-container>

    <h1 class="display-2">
      Page Not Found
    </h1>

  </v-container>
</template>
<script>
  export default {

  }
</script>
